<template>
  <div>
    <LvDropdownMultiCategorySelect
      :value="value"
      outline
      label="標籤"
      title="標籤"
      :scope="_tagScope"
      :createUrl="_tagCreateUrl"
      :scroll="scrollTop"
      :menuItems="factoryTag.list"
      :createFields="factoryTag.createFields"
      :updateFields="factoryTag.updateFields"
      :setDeletePopupInfo="$_setDeletePopupInfo"
      :isLoadingItems="isLoading.list"
      :customValidFunction="$_checkingIsNameDuplicate"
      @created="$_getTagList()"
      @delete="$_onDeleteFactoryTag($event)"
      @update="$_onUpdateFactoryTag($event)"
      @input="$emit('input', $event)"
      @validate-error="$_onValidateError"
    />
    <LvWarningPopup ref="LvWarningPopup" title="名稱重複，請重新輸入" />
  </div>
</template>

<script>
import S_scope from '@/service/api/v1/scope';
import S_factoryTag from '@/service/api/v1/factory_tag';
import H_factoryTag from '@/helpers/factoryTag';
import Spare_factoryTag from '@/spare/factory-tag';

export default {
  props: {
    scrollTop: {
      type: [Number, String],
    },
    value: {
      type: Array,
    },
  },
  data() {
    return {
      isLoading: {
        list: false,
      },
      factoryTag: {
        list: Spare_factoryTag.list,
        createFields: Spare_factoryTag.createFields,
        updateFields: Spare_factoryTag.updateFields,
      },
    };
  },
  computed: {
    _tagScope() {
      return {
        isCreatable: S_scope.$_isAvailable(['factory-tag-create']),
        isUpdatable: S_scope.$_isAvailable(['factory-tag-update']),
        isDeletable: S_scope.$_isAvailable(['factory-tag-delete']),
      };
    },
    _tagCreateUrl() {
      return S_factoryTag.createUrl();
    },
  },
  watch: {
    'isLoading.list': {
      handler() {
        this.$emit('loading', this.isLoading.list);
      },
    },
  },
  async mounted() {
    await this.$_getTagList();
  },
  methods: {
    async $_setDeletePopupInfo($event) {
      return await H_factoryTag.setDeletePopupInfo($event);
    },
    async $_getTagList() {
      this.isLoading.list = true;
      const params = {
        order_by: 'sequence',
        order_way: 'asc',
        get_all: 1,
      };
      const res = await S_factoryTag.index(params);
      this.factoryTag.list = H_factoryTag.setDropdownCustomItems(res);
      this.isLoading.list = false;
    },
    async $_onDeleteFactoryTag($event) {
      const { value: id } = $event;
      await S_factoryTag.delete(id);
      await this.$_getTagList();
    },
    async $_onUpdateFactoryTag($event) {
      const { value: id, name, sequence } = $event;
      if (this.$_checkingIsNameDuplicate(name)) {
        this.$refs.LvWarningPopup.$_onOpenPopup();
        return;
      }
      const data = {
        name,
        sequence,
      };
      await S_factoryTag.update(id, data);
      await this.$_getTagList();
    },
    $_checkingIsNameDuplicate(item) {
      if (!item?.name || !this.factoryTag?.list[0]?.menu?.length) return true;
      const name = item.name;
      const allNameSet = new Set(this.factoryTag.list[0].menu.map(item => item.text));
      return !allNameSet.has(name);
    },
    $_onValidateError() {
      this.$refs.LvWarningPopup.$_onOpenPopup();
    },
  },
};
</script>
